<script setup lang="ts">
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { PhX } from '@phosphor-icons/vue'
import AppHeader from '@/components/shared/AppHeader.vue'
import AppFooter from '@/components/shared/AppFooter.vue'
import MobileBottomNav from '@/components/shared/MobileBottomNav.vue'

const route = useRoute()
const router = useRouter()

// The backend redirects here with ?login_error=1 if the Google sign-in
// redirect flow failed (state mismatch, code exchange, etc.) - surface it
// once, then drop the query param so it doesn't linger on refresh/share.
const showLoginError = ref(route.query.login_error === '1')
if (showLoginError.value) {
  const { login_error: _dropped, ...rest } = route.query
  void router.replace({ query: rest })
}
</script>

<template>
  <div class="min-h-screen flex flex-col bg-background text-foreground">
    <AppHeader />
    <div
      v-if="showLoginError"
      class="mx-auto flex w-full max-w-6xl items-center justify-between gap-3 px-4 pt-4 sm:px-6 lg:px-10"
    >
      <div class="flex w-full items-center justify-between gap-3 rounded-xl border border-destructive/30 bg-destructive/10 px-4 py-3 text-sm text-foreground">
        <span>Sign-in with Google didn't complete. Please try again.</span>
        <button
          type="button"
          class="shrink-0 rounded-full p-1 text-muted-foreground transition hover:bg-background/60 hover:text-foreground"
          aria-label="Dismiss"
          @click="showLoginError = false"
        >
          <PhX :size="16" />
        </button>
      </div>
    </div>
    <main class="flex-1 pb-20 md:pb-0">
      <slot />
    </main>
    <AppFooter class="pb-20 md:pb-0" />
    <MobileBottomNav />
  </div>
</template>



